import Logo from '@/components/Logo'
import Account from '@/sinister/header/components/Account'
import Cart from '@/sinister/header/components/Cart'
import Categories from '@/sinister/header/components/Categories'
import CustomPages from '@/sinister/header/components/CustomPages'
import Favorites from '@/sinister/header/components/Favorites'
import Helper from '@/sinister/header/components/Helper'
import OpModel from '@/sinister/header/components/OpModel'
import { useHeaderContext } from '@/sinister/header/contexts/HeaderContext'

import Search from '@mercadoni/sinister/dist/cjs/search'

import { Suspense } from 'react'
import styled from 'styled-components'

const StyledGrid = styled.header`
  display: grid;
  grid-template-areas:
    'main'
    'secondary';
  grid-template-rows: 94px 40px;
  line-height: normal;
  .header {
    &__main {
      grid-area: main;
      background-color: var(
        --app-header-background-desktop-v3,
        var(--app-header-background-desktop)
      );
      padding: 0px 32px;
      display: grid;
      gap: var(--spacing-margin-medium);
      grid-template-areas: 'logo categoryTree search account icons';
      grid-template-columns:
        auto minmax(150px, max-content)
        1fr minmax(150px, max-content) auto;
      align-items: center;

      @media screen and (max-width: 960px) {
        padding: 0px 16px;
        gap: var(--spacing-margin-xSmall);
        grid-template-columns:
          auto auto
          1fr auto minmax(auto, max-content);
      }
    }

    &__secondary {
      grid-area: secondary;
      background-color: var(
        --app-subheader-background-desktop-v3,
        var(--app-subheader-background-desktop)
      );
      padding: 8px 32px;
      display: grid;
      gap: var(--spacing-margin-medium);
      ${({
        langEnable,
        helperEnable,
      }: {
        langEnable: boolean
        helperEnable: boolean
      }) => `
      grid-template-areas: 'opModel customPages ${
        helperEnable ? 'helper' : ''
      } ${langEnable ? 'language' : ''}';
      grid-template-columns: minmax(150px, max-content) minmax(150px, 1fr) ${
        helperEnable ? 'minmax( 100px, max-content)' : ''
      } ${langEnable ? 'minmax( 30px, max-content)' : ''};`}
      @media screen and (max-width: 960px) {
        padding: 0px 16px;
        gap: var(--spacing-margin-xSmall);
      }
    }

    &__icons {
      grid-area: icons;
      display: flex;
      align-items: center;
      justify-content: center;
      gap: var(--spacing-margin-medium);
      @media screen and (max-width: 960px) {
        gap: var(--spacing-margin-xSmall);
      }
    }

    &__search {
      grid-area: search;
      justify-content: center;
      display: flex;
      .searchInput input.ant-input {
        font-size: var(--app-subheader-fontsize-s3, --typography-size-s3);
      }
    }

    &__logo {
      grid-area: logo;
      max-width: 200px;
      min-width: 100px;
    }

    &__categoryTree {
      grid-area: categoryTree;
    }

    &__account {
      grid-area: account;
      @media screen and (max-width: 960px) {
        background: transparent;
        padding: 0;
        .account-menu__content {
          display: none;
        }
      }
    }
  }
`

const LayoutA = () => {
  const {
    maxItemsInline,
    store: { reference },
    langConfig,
    parsedHelpers,
    initialSearchValue,
    clientId,
    onClickSearch,
    onClickSuggested,
    placeholder,
    pathname,
    enabledSearchAutocomplete,
    initialCategories,
    logo,
    slug,
    domain,
  } = useHeaderContext()
  return (
    <StyledGrid
      className="header"
      langEnable={langConfig?.enabled || false}
      helperEnable={!!parsedHelpers?.length}
    >
      <div className="header__main">
        <Logo
          className="header__logo"
          src={logo}
          slug={slug}
          domain={domain}
          height={50}
        />
        <Categories
          className="header__categoryTree"
          initialCategories={initialCategories}
        />
        <Suspense fallback="">
          <Search
            enabledSearchAutocomplete={enabledSearchAutocomplete}
            className="header__search"
            storeReference={reference}
            initialValue={initialSearchValue}
            clientId={clientId}
            onClickSearch={onClickSearch}
            onClickSuggested={onClickSuggested}
            placeholder={placeholder}
            pathname={pathname}
          />
        </Suspense>
        <Account className="header__account" />
        <div className="header__icons">
          <Favorites />
          <Cart />
        </div>
      </div>
      <div className="header__secondary">
        <OpModel />
        <CustomPages maxItemsInline={maxItemsInline || 6} />
        <Helper />
      </div>
    </StyledGrid>
  )
}

export default LayoutA
